<script setup lang="ts">
import Lock from "../icons/Lock.vue";
import appConfig from "../../lib/appConfig";
import { useAuthStore } from "../../stores/authStore";

const authStore = useAuthStore();
</script>

<template>
  <div class="fixed inset-0 bg-background-overlay/40 z-40">
    <div class="modal-container max-w-md p-4">
      <Lock weight="fill" size="42" class="text-icon-brand" />
      <div class="py-6">
        <h2 class="text-xl font-bold">
          {{ $t("article_page.no_access.title") }}
        </h2>
        <p class="text-text-secondary mt-2">
          {{ $t("article_page.no_access.description") }}
        </p>
      </div>
      <div class="grid grid-cols-2 gap-3">
        <RouterLink to="/articles" class="btn-secondary">
          {{ $t("article_page.no_access.close_button") }}
        </RouterLink>
        <button
          @click="authStore.showLoginModal = true"
          class="btn-primary"
          v-if="!authStore.user"
        >
          {{ $t("common.sign_in") }}
        </button>
        <a v-else class="btn-primary" :href="appConfig.links.subscription_url">
          {{ $t("common.subscribe") }}
        </a>
      </div>
    </div>
  </div>
</template>
